import { DateTime } from "luxon";

export function convertToDate(
  inputString: string,
  fromFormat: string,
  utc?: boolean
): Date | undefined {
  const d = DateTime.fromFormat(
    inputString,
    fromFormat,
    utc ? { zone: "utc" } : {}
  );
  if (d.isValid) {
    return d.toJSDate();
  }
  return undefined;
}

export function nightBetweenDates(date1?: Date, date2?: Date): number {
  if (date1 && date2) {
    const departure = DateTime.fromJSDate(date1);
    const returnDate = DateTime.fromJSDate(date2);

    if (!departure.isValid || !returnDate.isValid) {
      return 0;
    }

    return returnDate.diff(departure, "days").days;
  }
  return 0;
}
